import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentConnectModule } from '../../components/SectionContentConnectModule'
import { useConnectModuleForm } from '../../containers/PageSectionConnectModule/useConnectModuleForm'
import { SiteLink } from '../../app-types'
import { INTRASITE_LINKS } from '../../constants'

const unsupportedMarketRedirect: SiteLink = {
  id: 'connect-unsupported-market-redirect',
  label: 'Unsupported Market Page',
  variant: 'auto',
  page: null,
  pageSection: null,
  article: null,
  internalHref: INTRASITE_LINKS.connectComingSoon.pagePath,
}

const businessBackground = {
  publicId: 'photography/connect-module-form-im-a-business-hero',
  alt: 'Hospitality staff serving guests at a catered event',
}

const prosBackground = {
  publicId: 'photography/connect-module-hero-image-im-a-pro',
  alt: 'Hospitality professional working a shift',
}

export const SectionContentInstanceConnectModule: React.FunctionComponent =
  () => {
    const form = useConnectModuleForm({
      notFoundRedirectLink: unsupportedMarketRedirect,
    })

    return (
      <Section
        padding={100}
        prerender
        cloudinaryBackground={
          form.role === 'Business' ? businessBackground : prosBackground
        }
      >
        <SectionContentConnectModule
          form={form}
          heading="GET GREAT SERVICE, A LA CARTE."
          prosHeading="PICK UP A SHIFT!"
          headingComponent="h1"
        />
      </Section>
    )
  }
